<header class="header-wrapper">
  <img
    (click)="navigateToLogin()"
    [src]="mercuryLogoPath"
    alt="Mercury Logo"
    class="mercury-logo"
  />

  <div class="flex">
    @if (hideButtons) {
      <me-button
        (click)="navigateToLogin()"
        class="login-button mr-4"
        label="Login"
        type="tertiary"
      ></me-button>
    }
    @if (!hideButtons) {
      <me-button
        (click)="navigateToLogin()"
        label="Book a Shipment"
        type="secondary"
      ></me-button>
    }
  </div>
</header>

<p-drawer
  [(visible)]="isSideBarVisible"
  class="mobile-sidebar"
  position="right"
>
  <ng-template #header>
    <img [src]="mercuryLogoBluePath" alt="Mercury Logo" class="mercury-logo"
  /></ng-template>
  <ng-template #content>
    <me-button
      (click)="navigateToLogin()"
      class="login-button w-full mt-3 mb-3"
      label="Login"
      type="tertiary"
    ></me-button>
    @if (!hideButtons) {
      <me-button
        (click)="navigateToLogin()"
        class="w-full"
        label="Request Demo"
        type="primary"
      ></me-button>
    }
  </ng-template>
</p-drawer>
